import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type MakeWinnerMutationVariables = Types.Exact<{
  input: Types.MakeWinnerInput;
}>;

export type MakeWinnerMutationResponse = Pick<Types.Mutation, 'makeWinner'>;

export const MakeWinnerDocument = `
    mutation MakeWinner($input: MakeWinnerInput!) {
  makeWinner(input: $input)
}
    `;

export const useMakeWinnerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    MakeWinnerMutationResponse,
    TError,
    MakeWinnerMutationVariables,
    TContext
  >,
) => {
  return useMutation<MakeWinnerMutationResponse, TError, MakeWinnerMutationVariables, TContext>(
    ['MakeWinner'],
    (variables?: MakeWinnerMutationVariables) =>
      appFetcher<MakeWinnerMutationResponse, MakeWinnerMutationVariables>(
        MakeWinnerDocument,
        variables,
      )(),
    options,
  );
};

useMakeWinnerMutation.getKey = () => ['MakeWinner'];
